// import React, { useState, ChangeEvent, FormEvent } from "react";
// import styles from "./AddSeries.module.css";
// import { createSeries } from "../../../service/series";

// const AddSeries = () => {
//   const [formData, setFormData] = useState({
//     id: "",
//     title: "",
//     description: "",
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");

//   const handleChange = (
//     e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//   ) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e: FormEvent) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setMessage("");
//     setError("");

//     try {
//       // Validate input
//       if (!formData.id || !formData.title) {
//         throw new Error("ID and Title are required");
//       }

//       // Create series
//       await createSeries(formData);

//       setMessage("Series created successfully!");
//       // Reset form
//       setFormData({
//         id: "",
//         title: "",
//         description: "",
//       });
//     } catch (err: any) {
//       console.error("Error creating series:", err);
//       setError(err.message || "Failed to create series");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className={styles.container}>
//       <h1 className={styles.title}>Create New Series</h1>

//       <form onSubmit={handleSubmit} className={styles.form}>
//         <div className={styles.formGroup}>
//           <label className={styles.label}>Series ID *</label>
//           <input
//             type="text"
//             name="id"
//             value={formData.id}
//             onChange={handleChange}
//             required
//             className={styles.input}
//             placeholder="e.g., bar-stool"
//             pattern="[a-z0-9-]+"
//             title="Lowercase letters, numbers, and hyphens only"
//           />
//           <p className={styles.hint}>
//             Unique identifier (lowercase, hyphens allowed)
//           </p>
//         </div>

//         <div className={styles.formGroup}>
//           <label className={styles.label}>Title *</label>
//           <input
//             type="text"
//             name="title"
//             value={formData.title}
//             onChange={handleChange}
//             required
//             className={styles.input}
//             placeholder="e.g., Bar Stool Series"
//           />
//         </div>

//         <div className={styles.formGroup}>
//           <label className={styles.label}>Description</label>
//           <textarea
//             name="description"
//             value={formData.description}
//             onChange={handleChange}
//             rows={4}
//             className={`${styles.input} ${styles.textarea}`}
//             placeholder="Describe the series..."
//           />
//         </div>

//         <button
//           type="submit"
//           className={styles.submitButton}
//           disabled={isSubmitting}
//         >
//           {isSubmitting ? "Creating..." : "Create Series"}
//         </button>

//         {message && <div className={styles.successMessage}>{message}</div>}
//         {error && <div className={styles.errorMessage}>{error}</div>}
//       </form>
//     </div>
//   );
// };

// export default AddSeries;
import React, { useState, useEffect } from "react";
import styles from "./AddSeries.module.css";
import { Series } from "../../../interface/series";
import { createSeries, updateSeries } from "../../../service/series";
// import { createSeries, updateSeries } from "../service/series";
// import { Series } from "../interfaces/series";

interface AddSeriesProps {
  onSuccess: () => void;
  initialData?: Series | null;
}

const AddSeries: React.FC<AddSeriesProps> = ({ onSuccess, initialData }) => {
  const [formData, setFormData] = useState({
    id: "",
    title: "",
    description: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id,
        title: initialData.title,
        description: initialData.description || "",
      });
    }
  }, [initialData]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");
    setError("");

    try {
      if (!formData.id || !formData.title) {
        throw new Error("ID and Title are required");
      }

      if (initialData) {
        // Update existing series
        await updateSeries(initialData.id, {
          title: formData.title,
          description: formData.description,
        });
        setMessage("Series updated successfully!");
      } else {
        // Create new series
        await createSeries(formData);
        setMessage("Series created successfully!");
      }

      // Reset form for new entries
      if (!initialData) {
        setFormData({
          id: "",
          title: "",
          description: "",
        });
      }

      onSuccess();
    } catch (err: any) {
      console.error("Error saving series:", err);
      setError(err.message || "Failed to save series");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {initialData ? "Update Series" : "Create New Series"}
      </h2>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Series ID *</label>
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            required
            className={styles.input}
            placeholder="e.g., bar-stool"
            pattern="[a-z0-9-]+"
            title="Lowercase letters, numbers, and hyphens only"
            disabled={!!initialData}
          />
          <p className={styles.hint}>
            {initialData
              ? "ID cannot be changed"
              : "Unique identifier (lowercase, hyphens allowed)"}
          </p>
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label}>Title *</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            className={styles.input}
            placeholder="e.g., Bar Stool Series"
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label}>Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={4}
            className={`${styles.input} ${styles.textarea}`}
            placeholder="Describe the series..."
          />
        </div>

        <button
          type="submit"
          className={styles.submitButton}
          disabled={isSubmitting}
        >
          {isSubmitting
            ? initialData
              ? "Updating..."
              : "Creating..."
            : initialData
            ? "Update Series"
            : "Create Series"}
        </button>

        {message && <div className={styles.successMessage}>{message}</div>}
        {error && <div className={styles.errorMessage}>{error}</div>}
      </form>
    </div>
  );
};

export default AddSeries;
